import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  created: function() {
    router.replace('/')
    // getData()
  },
  render: h => h(App),
}).$mount('#app')

// function getData() {
//   store.dispatch('getData').then(statusCode => {
//     if (store.state.status === 'after_race') {
//       router.replace('/result')
//     } else {
//       router.replace('/')
//       setTimeout(() => {
//         this.getData()
//       }, 10000)
//     }
//   })
// }
